<div class="client-card">
  <div class="name-and-vat">
    <div class="client-name">
      <span>{{ client.company_name }}</span>
    </div>
    <div class="client-vat">
      <span>P.IVA: </span>
      <span>{{ client.vat_number }}</span>
    </div>
  </div>
</div>
